import {
    INSTANCE_TEMPLATE_LIST,
    INSTANCE_TEMPLATE_PAGE_LIST,
    HIDE_LOADING,
    SET_INSTANCE_ADD_EDIT,
    SHOW_LOADING,
    INSTANCE_TEMPLATE_MESSAGE,
    INSTANCE_TEMPLATE_PAGE_DRAFT_LIST,
    INSTANCE_TEMPLATE_PAGE_DRAFT_MESSAGE,
    TAB_VALUE,
  } from "redux/constants/templatePageInstance";
  
  const initState = {
    loading: true,
    addEditPageInstanceValue : false,
    templates: [],
    templatesPagesDrafts:[],
    templatePages:[],
    selectedTab:"drafts",
    permissions : localStorage.getItem("permissions")!==""?JSON.parse(localStorage.getItem("permissions")):"",
  };
  
  const templatePageInstance = (state = initState, action) => {
    switch (action?.type) {
        case INSTANCE_TEMPLATE_LIST:
            return {
              ...state,
              templates: action.payload,
              addEditPageInstanceValue:false,
              allowRedirect: false,
              loading: false,
              message: "",
            };
        case INSTANCE_TEMPLATE_MESSAGE:
            return {
                ...state,
                message: messageRead(action),
                status: action?.response?.status,
                showMessage: true,
                loading: false,
              };
        case INSTANCE_TEMPLATE_PAGE_DRAFT_LIST:
            return {
              ...state,
              templatePagesDrafts: action.payload,
              addEditPageInstanceValue:false,
              allowRedirect: false,
              loading: false,
              message: "",
            };
        case INSTANCE_TEMPLATE_PAGE_LIST:
          return {
            ...state,
            templatePages: action.payload,
            addEditPageInstanceValue:false,
            allowRedirect: false,
            loading: false,
            message: "",
          };
        case INSTANCE_TEMPLATE_PAGE_DRAFT_MESSAGE:
            return {
                ...state,
                message: messageRead(action),
                status: action?.response?.status,
                showMessage: true,
                loading: false,
              };
        case SHOW_LOADING: {
            return {
                ...state,
                loading: true,
            };
            }
        case HIDE_LOADING: {
        return {
            ...state,
            loading: false,
        };
        }
        case SET_INSTANCE_ADD_EDIT:
            return {
              ...state,
              addEditPageInstanceValue: action.addEditPageInstanceValue,
              loading: false,
              appRolePermissions: [],
            };
        case TAB_VALUE:
          return {
              ...state,
              selectedTab : action?.selectedTab,
              addEditPageInstanceValue : false
          }
      default:
        return state;
    }
  };
  
  const messageRead=(action)=>{
    if(action?.response?.status==401 || action?.response?.response?.status){
      return "Unauthorized"
    }
      if(action?.response && action?.response?.response && action?.response?.response?.data && action?.response?.response?.message){
       return action?.response?.response?.data?.message;
      }else if(action?.response && action?.response?.data && action?.response?.data?.message){
          return action?.response?.data?.message;
      }else if(action?.response && action?.response?.data && action?.response?.data?.message){
          return action?.response?.data?.message;
      }else if(action?.data?.message){
          return action?.data?.message;
      }else if(action?.data){
          return action?.data;
      }else{
          return "something went wrong"
      }
  }
  
  export default templatePageInstance;
  